import * as Yup from "yup";

import { FormHelper, ValidationHelper } from "./index.js";

// Exported for the same reason as ListingFields (see helpers/Listing.js): the
// dictation checklist reads the form's own mandatory list rather than copying it.
export const ProductFields = {
  required: [
    "category_id",
    "brand_id",
    "model_id",
    "reference_number",
    "images",
  ],
  optional: ["query"],
  eavFields: ["case_material", "dial_color", "case_diameter", "color"],
};

const ProductHelper = {
  getInitialValues: (product) => {
    const fields = ProductFields.required.concat(ProductFields.optional);

    // Product fields
    const initialValues = FormHelper.initialValues(fields, product);

    // Product Images
    initialValues.images = product?.images?.map((i) => i.id);

    // Values of EAV (Entity-Attribute-Value) Product fields, indexed by field name
    const values = product?.values;
    initialValues.values = {};

    for (let i = 0; i < ProductFields.eavFields.length; i++) {
      const eavField = ProductFields.eavFields[i];
      initialValues.values[eavField] = values ? values[eavField]?.value : "";
    }

    return initialValues;
  },

  getValidationSchema: (categoryId) => {
    const validationRules = ValidationHelper.requiredRules(
      ProductFields.required
    );

    validationRules.values = ValidationHelper.schema(
      ProductHelper.getRequiredEAVFields(categoryId)
    );

    return Yup.object(validationRules);
  },

  getRequiredEAVFields: (categoryId) => {
    const fields = [];

    if (categoryId === 9) {
      fields.push("case_material");
      fields.push("case_diameter");
      fields.push("dial_color");
    }

    if (categoryId === 3) {
      fields.push("color");
    }

    return fields;
  },

  getChronoProductName: (item) => {
    const caseMaterial = item.product?.values?.case_material;
    const dialColor    = item.product?.values?.dial_color;
    const ref          = item.product?.reference_number;
    const attrs        = [caseMaterial, dialColor, ref].filter(Boolean).join(" - ");
    const prefix       = item.year
      ? (item.condition === "new" ? `[New ${item.year}]` : `[${item.year}]`)
      : "";
    return [prefix, attrs].filter(Boolean).join(" ");
  },

  getEbayProductName: (item, listing) => {
    const brandName  = listing?.product?.brand?.name || item.product?.brand?.name || "";
    const modelName  = listing?.product?.model?.name || item.product?.model?.name || "";
    const brandModelPrefix = brandName && modelName ? `${brandName} ${modelName} ` : "";
    // eBay titles abbreviate "Stainless Steel" to "Steel" (chrono/WF keep the full value).
    const caseMaterialRaw = item.product?.values?.case_material;
    const caseMaterial = caseMaterialRaw
      ? caseMaterialRaw.replace(/Stainless Steel/gi, "Steel")
      : caseMaterialRaw;
    const dialColor    = item.product?.values?.dial_color;
    const ref          = item.product?.reference_number;
    const attrs        = [caseMaterial, dialColor, ref].filter(Boolean).join(" - ");
    const prefix       = item.condition === "new" ? `[New ${item.year}]` : `[${item.year}]`;
    return attrs ? `${brandModelPrefix}${prefix} ${attrs}` : `${brandModelPrefix}${prefix}`;
  },
};

export default ProductHelper;
